export function getComponentCategoryName(i18n, typeLabelPL, typeLabelEN) {
    return i18n.language === 'en' ? typeLabelEN : typeLabelPL;
}
export default getComponentCategoryName;
